<template>
  <div class="a">
    <Nav/>
    <PageBannerBig :banner="banner"></PageBannerBig>
    <div class="service-content">
      <div class="content">
        <div class="title-name">证券业解决方案</div>
        <div class="title-sub">概述</div>
        <div class="text">
          证券业数据服务解决方案是面向证券行业客户提供的，针对各类交易数据进行采集、统计、分析、探查、预警、报告的专用解决方案。该方案提供了从基础信息到整合信息，从海量明细到宏观聚合的数据全流域综合管理，是支持证券业机构不同部门和主体在信息分析、信息统计、监管合规、信息披露等各个环节的应用组合。
        </div>
        <div class="title-sub">解决方案</div>
        <div class="text">
          信息分析<br>
          以市场分析、上市公司分析、投资者分析等为主要内容，充分依托数据仓库相关技术，为客户提供包括：市场风险度分析、上市公司财务分析、投资者交易行为分析等相关分析服务和应用系统建设。<br>
          信息统计<br>
          以市场行业情况、上市公司报告、投资者分析等为主要内容，围绕报表、报告，融合多维分析、格式化报表、Ad-hoc分析等多种交互模式，为客户提供包括证券市场概貌、行业板块概貌、上市公司财务报告分析、投资者交易分析等统计分析和数据探查服务。<br>
          信息监管<br>
          依托完善的数据治理体系，针对市场上存在的各种违规违法行为，结合各种统计分析和监管模型，对市场的异常行为进行监控，构建高效、准确的监管体系。解决方案包括一系列的市场风险指标、定期监管等应用。
        </div>
        <div class="title-sub">能力优势</div>
        <div class="text">
          持续服务<br>
          10+年以来，持续为证券交易机构提供数据分析、数据挖掘和技术开发服务，专业、专注、持续的良好合作锻造了一支强有力的证券行业技术服务团队。<br>
          行业理解<br>
          凭借多年持续的证券业数据仓库、数据集市建设经验在证券行业数据服务、应用开发和测试等专业领域积累了丰富的经验，深入理解客户需求，并在众多专业领域与证券机构保持深度合作。
        </div>
        <div class="title-sub">典型客户</div>
        <div class="text">
          中国证监会<br>
          中证监测<br>
          上海证券交易所<br>
          深圳证券交易所<br>
          中证指数有限公司
        </div>
      </div>
      <Mission/>
    </div>

    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerBig from '@/components/PageBannerBig'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerBig,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/solution-banner.jpg"),
        title: "为您提供专业的解决方案",
        sub: "专业的服务 高效的方案"
      }
    }
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 38px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        color: #333;
        line-height: 24px;
        font-size: 20px;
        text-align: left;
        box-sizing: border-box;
        width: 200px;
        margin-top: 30px;
        margin-bottom: 10px;
        border-radius: 30px;
      }
      .text{
        color: #666;
        line-height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        .img{
          padding: 30px;
          margin: 20px auto;
          background: #fff;
          text-align: center;
        }
      }
    }
}
</style>